import React, { Component } from 'react';
import { Input } from './Input';
import { Button } from './Button';
import { Gateway } from '../BaseUrl';
import { Form } from './Form';

export class ForgotPassword extends Component {
    displayName = ForgotPassword.name

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            sent: false,
            hasError: false,
            errorMessage: "",
            email: "",
            emailValid: false
        };

        this.email = React.createRef();
        this.callReset = this.callReset.bind(this);
    }

    callReset() {
        this.setState({
            loading: true
        });
        var err = false;
        fetch(Gateway + '/reset', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                Email: this.state.email
            })
        }).then(response => {
            if (response.ok) {
                return response.text();
            } else {
                if (response.status == 503 || response.status == 403) {
                    throw Error(response.statusText);
                } else {
                    err = true;
                    return response.json();
                }
            }
        }).then(data => {
            if (err) {
                this.setState({
                    errorMessage: data.message,
                    sent: true,
                    hasError: true,
                    loading: false
                });
            } else {
                this.setState({
                    loading: false,
                    sent: true,
                    email: "",
                    hasError: false
                });
            }
            
        }).catch((e) => {
            this.setState({
                loading: false,
                sent: true,
                hasError: true
            });
            console.log("error", e);
        });
    };

    render() {
        const alertStyle = { padding: "3px", textAlign: "center", border: "1px solid #e3e3e3", borderRadius: "3px", marginBottom: "10px"};
        return (
            <div style={{ width: "100%" }}>
                <div className="page-container" >
                    {
                        this.state.sent ?
                        <div>
                            {
                                this.state.hasError ?
                                <div>
                                    <h2 className="text-center"> Oops something went wrong! </h2>
                                    <div className="error" style={{ border: "1px solid", marginBottom: "15px", padding: "5px 10px", borderRadius: "3px" }}>
                                        <i className="fas fa-exclamation-triangle" /> {this.state.errorMessage}
                                    </div>
                                </div>
                                :
                                <div>
                                    <h2 className="text-center">Thank you</h2>
                                    <p>An email has been sent to you with a link to reset your password. If you have not recieved an email try submitting the form again.</p>
                                </div>
                            }
                        </div>
                        :
                        this.props.children == null ? <div>
                            <h2 className="text-center"> Forgot password </h2>
                            <p>Enter your email/username and we will send you a link to reset your password.</p>
                        </div> : this.props.children
                    }
                    <Form onSubmit={() => { this.callReset() }}>
                        <Input placeholder="Email"
                            ref={this.email}
                            required={true}
                            rules={['isValidEmail']}
                            value={this.state.email}
                            isValid={(e) => { this.setState({ isValid: e }) }}
                            onChange={(e) => this.setState({ email: e.target.value.trim() })}
                        />
                        <Button type="submit" value="Send" loading={this.state.loading} />
                    </Form>
                </div>                
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ForgotPassword.js